import React from 'react';
import ProfCourseGrid from '../components/ProfCourseGrid';

const PageProfCourseGridNoEdit = (props) => <ProfCourseGrid id={props.id} />;

export default PageProfCourseGridNoEdit;
